/* eslint-disable react/jsx-one-expression-per-line */
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toMonthString } from '../../utils/formatTime';
import useTopFeatures from './useTopFeatures';
import { getTopFeatures } from '../../features';
import { TopFeaturesCard } from '../../modules/TopFeatures';
import DashboardCards from '../../components/DashboardCard/DashboardCards';

export default function TopFeatures({
  accountId,
  accountName,
  isShare,
  tenantId,
  pkgId,
  accountOrgId,
}) {
  const dispatch = useDispatch();

  const {
    topFeatureUsage,
    refreshTopFeatures,
    setRefreshTopFeatures,
    handleSortModelChange,
    sortModel,
  } = useTopFeatures();

  useEffect(() => {
    if (accountId) {
      dispatch(getTopFeatures({
        accountId, isShare, tenantId, accountOrgId,
      }));
    } else {
      dispatch(getTopFeatures({
        isShare, tenantId, accountOrgId,
      }));
    }
  }, [refreshTopFeatures, tenantId, pkgId, accountOrgId]);

  const navigate = useNavigate();

  const handleClick = () => {
    if (accountId || accountName) {
      navigate(`/account-page/feature-usage?accountId=${accountId}`, { state: { accountName, accountId } });
    } else {
      navigate('/feature-usage');
    }
  };

  return (
    <DashboardCards
      title="Top Features"
      subHeading={`Data ${accountId ? '' : 'of Active Accounts '}for ${toMonthString(topFeatureUsage?.timePeriod)}`}
      showButton={!isShare}
      buttonText="more"
      onClick={handleClick}
    >
      <TopFeaturesCard
        loading={topFeatureUsage?.loading}
        error={topFeatureUsage?.error}
        data={topFeatureUsage?.topFeatures}
        refresh={setRefreshTopFeatures}
        message="No Rows"
        accountId={accountId}
        sortModel={sortModel}
        handleSortModelChange={handleSortModelChange}
      />
    </DashboardCards>
  );
}
